import React from 'react'
import CaseStudies from '../src/pages/CaseStudies/CaseStudies'

const caseStudies = () => {
  return (
    <div>
     <CaseStudies />
    </div>
  )
}

export default caseStudies